import { ArrowLeftOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Flex, Input, Space, Tag, Typography,
} from 'antd';
import SkeletonLoading from 'components/SkeletonLoading';
import Banners from 'components/Layout/Header/Banners';
import useIsDesktop from 'hooks/useIsDesktop';
import { useNavigate } from 'react-router';
import React from 'react';
import { useAppHistory } from 'hooks/useAppHistory';

const { Title } = Typography;

function Header({
  title,
  description,
  tag,
  extra,
  onSearch,
  searchPlaceholder = 'Search...',
  backTitle,
  backPath,
  loading = false,
  action,
}) {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { goBack: appGoBack } = useAppHistory();

  const goBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
      // appGoBack();
    }
  };
  return (
    <>
      <div className="sticky top-0 z-10" style={{ background: '#fff' }}>
        {onSearch && (
          <Input
            size="large"
            placeholder={searchPlaceholder}
            prefix={<SearchOutlined className="mr-2" />}
            onChange={onSearch}
            className="rounded-none h-[50px] pl-4 lg:pl-12 pr-8 border-l-0 border-r-0"
            allowClear
          />
        )}
        {backTitle && (
          <Flex
            onClick={goBack}
            gap={8}
            className="ml-5 lg:ml-16 mr-4 lg:mr-8  lg:py-6 py-4"
            style={{ cursor: 'pointer', color: '#717679' }}
          >
            <ArrowLeftOutlined />
            <span className="font-weight-bolder">{backTitle}</span>
          </Flex>
        )}
      </div>

      <Flex
        vertical
        className="pl-5 lg:pl-16 mr-4 lg:mr-8  "
        style={{
          paddingTop: backTitle ? 0 : 24,
          paddingBottom: backTitle ? 0 : 24,
          borderBottom: '1px solid #0000000F',
        }}
      >
        <Banners />
        {loading && (
          <SkeletonLoading
            borderRadius="2px"
            width="250px"
            height="36px"
            count={1}
          />
        )}

        {!loading && (
          <Flex justify="space-between" align="center">
            <Space direction="vertical" className="w-full">
              <Flex justify="space-between" gap={4} className="flex-col md:flex-row">
                <Space className="flex-col md:flex-row items-start md:items-center">
                  <Title level={isDesktop ? 2 : 3} className="m-0">
                    {title}
                  </Title>
                  {tag && (typeof tag === 'string' ? <Tag>{tag}</Tag> : tag)}
                </Space>
                {extra && (
                  <Flex gap={8} className="flex-col sm:flex-row">
                    {extra}
                  </Flex>
                )}
              </Flex>
              {description && (
                <p dangerouslySetInnerHTML={{ __html: description }} style={{ color: '#10111299' }} />
              )}
            </Space>
          </Flex>
        )}
      </Flex>
    </>
  );
}

export default Header;
